import { render, staticRenderFns } from "./Mocks.vue?vue&type=template&id=a72d6dc6&scoped=true&"
import script from "./Mocks.vue?vue&type=script&lang=js&"
export * from "./Mocks.vue?vue&type=script&lang=js&"
import style0 from "./Mocks.vue?vue&type=style&index=0&id=a72d6dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72d6dc6",
  null
  
)

export default component.exports